import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * Reusable shell for legal pages — Privacy Policy, Terms, Cookie Policy.
 * Black hero with title + last-updated date, then long-form prose body.
 */
const LegalPage = ({ title, lastUpdated, children, testid }) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    const previousTitle = document.title;
    document.title = `${title} — Grouth`;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);

  return (
    <div className="bg-[#FDFEFA] min-h-screen" data-testid={testid}>
      {/* Hero */}
      <div className="bg-[#242326] pt-24 pb-14">
        <div className="max-w-[820px] mx-auto px-6 md:px-12">
          <button
            onClick={() => navigate('/')}
            data-testid={`${testid}-back`}
            className="inline-flex items-center gap-2 text-white/50 text-sm font-['Inter'] mb-6 hover:text-white transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back home
          </button>
          <motion.h1
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-white text-4xl md:text-5xl lg:text-[56px] font-light leading-[1.1] tracking-tight font-['Inter']"
          >
            {title}
          </motion.h1>
          {lastUpdated && (
            <p className="text-white/40 text-xs font-['Lato'] uppercase tracking-wider mt-4">
              Last updated · {lastUpdated}
            </p>
          )}
        </div>
      </div>

      {/* Body */}
      <div className="max-w-[820px] mx-auto px-6 md:px-12 py-12 md:py-16">
        <article className="legal-prose space-y-5 text-[#4A4A48] text-[16px] leading-[1.75] font-['Lato'] font-light">
          {children}
        </article>
      </div>
    </div>
  );
};

export default LegalPage;
